const Intersect = {
  bind (element, binding) {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return
    }
    const options = {
      root: null,
      threshold: parseInt(element.getAttribute('data-threshold') || 1.0),
      rootMargin: element.getAttribute('data-root-margin') || '0px'
    }
    let watcher = new IntersectionObserver((entries, observer) => {
      const isIntersecting = entries.some(entry => entry.isIntersecting)
      binding.value({entries, observer, isIntersecting, element})
    }, options)
    watcher.observe(element)
  }
}

export default Intersect



// WEBPACK FOOTER //
// ./src/bcq-ui/directives/intersect.js